import React from "react";

import * as Icon from "@phosphor-icons/react/dist/ssr";

interface Pros {
  heading: string;
  subHeading: string;
}

const Breadcrumb: React.FC<Pros> = ({ heading, subHeading }) => {
  return (
    <>
      <div className="breadcrumb-block w-full">
        <div className="breadcrumb-main bg-pink w-full shadow-lg">
          <div className="w-full py-2 md:py-3 px-4 md:px-8">
            <div className="max-w-7xl mx-auto flex flex-col items-center justify-center">
              <div className="text-content w-full flex items-center justify-center gap-4 md:gap-6">
                <div className="text-2xl md:text-3xl font-bold text-white tracking-tight">{heading}</div>
                <div className="flex items-center gap-2 text-sm md:text-base text-white font-medium">
                  <a href={"/"} className="hover:text-pink-200 transition-colors">Accueil</a>
                  <Icon.CaretRight size={16} className="font-semibold" />
                  <div className="font-semibold capitalize">{subHeading}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
